import React from 'react'

import { ArrowUturnLeftIcon, ArrowUturnRightIcon } from '@heroicons/react/24/outline'
import { ICellRendererParams } from 'ag-grid-community'
import ReactTooltip, { TooltipProps } from 'react-tooltip'

import { subStageMap } from './subStageMap'

export function ApplicationStateRenderer(params: ICellRendererParams) {
  const { value, data } = params

  const kickbackIndicator = data?.kickback?.active_indicator

  const tooltipConfig: TooltipProps = {
    place: 'right',
    class: 'py-1 px-3 rounded text-white text-sm',
  }

  return (
    <>
      {value && (
        <div className='flex w-full h-full items-center px-3'>
          <div
            className='text-sm font-light w-30 text-ellipsis overflow-hidden pl-2 border-l-[12px] border-solid py-1'
            style={{ borderColor: subStageMap[value]?.color ?? '#DEDEDE' }}
            data-tip={subStageMap[value]?.label ?? 'Unknown'}
            data-for='tooltip'
          >
            {subStageMap[value]?.label ?? 'Unknown'}
          </div>

          <ReactTooltip
            id='tooltip'
            place='right'
          />

          {kickbackIndicator === 'kickback' && (
            <>
              <ArrowUturnLeftIcon
                className='w-5 h-5 ml-3 text-orange-600'
                data-tip='This deal has been kicked back to this stage'
                data-for='kickback-tooltip'
              />
              <ReactTooltip
                id='kickback-tooltip'
                {...tooltipConfig}
              />
            </>
          )}

          {kickbackIndicator === 'resubmission' && (
            <>
              <ArrowUturnRightIcon
                className='w-5 h-5 ml-3 text-green-600'
                data-tip='This deal has been re-submitted after a kickback'
                data-for='resubmit-tooltip'
              />
              <ReactTooltip
                id='resubmit-tooltip'
                {...tooltipConfig}
              />
            </>
          )}
        </div>
      )}
    </>
  )
}
